const { trackMetric } = require('../collector');
const { supportsNavigatorApi } = require('../support');
const { NETWORK_SPEED, NETWORK_TYPE, USER_AGENT } = require('../../constants/metrics');

const connectionInformationMonitor = () => {
  if (!supportsNavigatorApi()) {
    return;
  }
  const { navigator } = window;
  if (navigator.connection) {
    if (navigator.connection.effectiveType) {
      trackMetric(NETWORK_TYPE, navigator.connection.effectiveType);
    }
    if (navigator.connection.downlink) {
      trackMetric(NETWORK_SPEED, `${navigator.connection.downlink}`);
    }
    if ('saveData' in navigator.connection) {
      trackMetric('save-data', navigator.connection.saveData);
    }
    if (navigator.connection.rtt) {
      trackMetric('rtt', `${navigator.connection.rtt}`);
    }
  }
  if (navigator.userAgent) {
    trackMetric(USER_AGENT, navigator.userAgent);
  }
};

module.exports = connectionInformationMonitor;
